/**
 * @author yuping.pang
 * @date 2024-07-24 16:09
 * @description 成品属性维护枚举
**/

// 停产枚举
export const STOP_PRODUCT = [
  { value: 'Y', label: '是' },
  { value: 'N', label: '否' }
];
